import { ISVGChartWidget } from '@/pages/Dashboards/dashboards.types'
import { IComputedParameterDef, IParameter } from '@/pages/Parameters/parameters.types'
import { CSSProperties, useMemo } from 'react'
import SVGChart from '..'
import svgUtils from '../svg.utils'
import useDataPointUpToTsWithComputedRef, {
  IUseDataPointUpToTsWithComputedRefProps,
} from '@/services/data/hooks/useDataPointUpToTsWithComputedRef'

interface IProps {
  widget: ISVGChartWidget
  lastResize?: number

  // For local svg files
  svgFileSrcString?: string
  textParameterPreprocessFn?: (parameter: IParameter, value: string) => string
  computed?: IComputedParameterDef[]
  wrapperStyle?: CSSProperties

  tsFrom: number
  tsTo: number
  tsCurrent: number
}

const StandaloneSvgChartRange = (props: IProps) => {
  const dataConfig = useMemo(() => {
    return svgUtils.extractDevicesAndParameters(props.widget.configuration.settings)
  }, [
    props.widget.configuration.settings.text,
    props.widget.configuration.settings.color,
    props.widget.configuration.settings.visibility,
    props.widget.configuration.settings.movements,
    props.widget.configuration.settings.rotations,
  ])

  const config: Omit<IUseDataPointUpToTsWithComputedRefProps, 'tsCurrent'> = useMemo(() => {
    return {
      id: props.widget.id.toString(),
      devices: dataConfig.devices,
      parameters: dataConfig.parameters,
      initialTsFrom: props.tsFrom,
      initialTsTo: props.tsTo,
      computed: props.computed,
      aggregate: false,
      live: false,
    }
  }, [dataConfig, props.tsFrom, props.tsTo, props.widget.id, props.computed])

  const dataRef = useDataPointUpToTsWithComputedRef({
    ...config,
    tsCurrent: props.tsCurrent,
  })

  return <SVGChart {...props} dataRef={dataRef.ref} />
}

export default StandaloneSvgChartRange
